<template>
    <div class="rn-breadcrumb-inner pt-8 pb-8 lg:pt-[30px] lg:pb-[30px]">
        <div class="container mx-auto">
            <div class="flex flex-wrap items-center">
                <div class="lg:w-1/2 md:w-1/2 w-full">
                    <h5 class="title text-center lg:text-start md:text-start">{{ title }}</h5>
                </div>
                <div class="lg:w-1/2 md:w-1/2 w-full">
                    <ul class="breadcrumb-list flex items-center justify-center lg:justify-end md:justify-end">
                        <li class="item"><router-link :to="root.url">{{ root.title }}</router-link></li>
                        <li class="separator mx-2"><i class="feather-chevron-right"/></li>
                        <li class="item current">{{ current }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Breadcrumb',
        props: {
            title: {
                type: String
            },
            root: {
                type: Object,
                default() {
                    return {
                        title: 'Home',
                        url: '/'
                    }
                }
            },
            current: {
                type: String
            }
        }
    }
</script>
